import { Maximize2, Minimize2, X } from "lucide-react";
import { useState } from "react";
import InsightsContentSection from "./InsightsContentSection";

export interface AIInsightsPanelParams {
    onClose: () => void
}

const AIInsightsPanel: React.FC<AIInsightsPanelParams> = ({
    onClose
}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    
    return (
        <div
            className={`fixed top-0 right-0 h-full bg-white shadow-2xl z-50 
            transition-all duration-300 ease-in-out
            ${isExpanded ? "w-full max-w-full" : "w-[60vw] max-w-[60vw] min-w-[60vw]"} 
            overflow-hidden`}
        >
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b">
            <h2 className="text-lg font-semibold">AI Insights</h2>
            <div className="flex gap-2">
                <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="p-2 rounded-full hover:bg-gray-100"
                >
                {isExpanded ? (
                    <Minimize2 className="w-5 h-5" />
                ) : (
                    <Maximize2 className="w-5 h-5" />
                )}
                </button>
                <button
                onClick={onClose}
                className="p-2 rounded-full hover:bg-gray-100"
                >
                <X className="w-5 h-5" />
                </button>
            </div>
            </div>

            {/* Content */}

            <div className="p-4 overflow-y-auto h-[calc(100%-64px)]">
                <InsightsContentSection />
            </div>
            
        </div>
            
    );
}

export default AIInsightsPanel;